import React, { Component } from 'react';
import { Modal, DatePicker } from 'antd';
import moment from 'moment';

const dateFormat = 'YYYY-MM-DD';
const { RangePicker } = DatePicker;

class RandomDateRange extends Component {
    state = {
        date: null,
        visible: false,
    }

    show = (params) => {
        const { startDate, endDate } = params;
        this.setState({
            visible: true,
            date: [moment(startDate), moment(endDate)],
        });
    }

    hide = () => {
        this.setState({
            visible: false,
        });
    }

    handleDateChange = (date, dateString) => {
        this.setState({ date });
    }

    submit = () => {
        const { date } = this.state;
        this.hide();
        this.props.changeFreeDate({
            startDate: date[0].format(dateFormat),
            endDate: date[1].format(dateFormat),
        });
    }

    render() {
        const { date, visible } = this.state;
        return (
            <Modal
                title="选择时间段"
                visible={visible}
                onOk={this.submit}
                onCancel={this.hide}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                maskClosable={false}
                width="400px"
            >
                <div style={{ padding: '30px 40px' }}><RangePicker value={date} allowClear={false} onChange={this.handleDateChange} /></div>
            </Modal>
        );
    }
}

export default RandomDateRange;


// WEBPACK FOOTER //
// ./src/components/homePage/myFocus/RandomDateRange.js